import { falseIfMissing } from 'protractor/built/util'

export class ColumnWidth {
  name: string
  preferredWidth: number
  minWidth: number
  shrinkOrder: number = undefined
  width: number
  userSet: boolean = false

  get changeAble(): boolean {
    if (this.shrinkOrder === undefined) {
      return false
    }
    return !this.userSet
  }

  shrink(n: number): number {
    if (n > this.width - this.minWidth) {
      n = this.width - this.minWidth
    }
    this.width -= n
    return n
  }

  expand(n: number): number {
    if (n > this.width - this.preferredWidth) {
      n = this.width - this.preferredWidth
    }
    this.width -= n
    return n
  }
}

export namespace ColumnWidth {
  export function compare(a: ColumnWidth, b: ColumnWidth) {
    if (a.shrinkOrder < b.shrinkOrder) {
      return 1;
    }
    if (a.shrinkOrder > b.shrinkOrder) {
      return -1;
    }
    return 0;
  }
}
